import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';

interface DashboardListEmptyProps extends WithColor {
  testID?: string;
}

const DashboardListEmpty: FC<DashboardListEmptyProps> = ({ C, testID }) => (
  <View
    testID={testID}
    style={{ paddingVertical: scale(48), alignItems: 'center', justifyContent: 'center' }}
  >
    <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('No data')}</Text>
  </View>
);

export default ColorWrapper(DashboardListEmpty);
